import { get } from 'lodash';
import { t } from 'utils/i18n';
import BaseError from './BaseError';

const getResponseErrorMessage = (error) => {
  if (error.response && error.response.data) {
    return get(error, 'response.data.error.message', t('serverDown'));
  }

  if (error.response && error.response.statusText) {
    return error.response.statusText;
  }

  return error.message === 'Network Error' ? t('networkError') : error.message;
};

class NetworkError extends BaseError {
  constructor(error, message) {
    super();
    this.status = error.response ? error.response.status : false;
    this.message = message || getResponseErrorMessage(error);
    this.errors = error.response?.data?.error?.errors;
  }
}

export default NetworkError;
